import { Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';

import { HomeWorkOutlined } from '@material-ui/icons';
import { RoundedBackgroundIcon } from '../common/roundedBackgroundIcon';
import { PointsAndFeesComponent } from '../fixFlip/pointsAndFeesAccordion';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

const useStyles = makeStyles(theme => ({
  paper: {
    border: `1px solid lightgray`,
    borderRadius: '16px !important',
    padding: theme.spacing(4),
  },
  tooltip: {
    backgroundColor: theme.palette.primary.main,
    fontSize: '1rem',
  },
}));

interface EconomicsCardProps {
  store: IQuoteTypeStore;
}

export const SinglePropertyEconomicsCard = observer(
  ({ store }: EconomicsCardProps) => {
    const classes = useStyles();

    return (
      <Paper className={classes.paper} elevation={0}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <RoundedBackgroundIcon
                  Icon={HomeWorkOutlined}
                  iconColor="#6D6D6D"
                />
              </Grid>
              <Grid item>
                <Typography variant="h4" style={{ color: '#6D6D6D' }}>
                  Points and Fees
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <PointsAndFeesComponent store={store} />
          </Grid>
        </Grid>
      </Paper>
    );
  }
);
